<dk-ticker-card
  titleText="Dönüşüm"
  total="16%"
  [percentage]="-2.3"
  contentClass="conversion"
></dk-ticker-card>
